import {ModuleWithProviders, NgModule, Optional, Provider, SkipSelf} from "@angular/core";
import {AuthConfig, AuthService} from "./auth.service";

@NgModule({})
export class AuthModule {
    constructor(@Optional() @SkipSelf() parentModule: AuthModule) {
        if (parentModule) {
            throw new Error('AuthModule is already loaded. Import it in the AppModule only');
        }
    }

    /**
     * Provide the AuthService.
     * @return ModuleWithProviders
     */
    static forRoot(config?: AuthConfig): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                AuthService,
                {provide: AuthConfig, useValue: config}
            ]
        };
    }

    static forRootWithFactoryProvider(configFactoryProvider: Provider): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                AuthService,
                configFactoryProvider
            ]
        };
    }
}
